import Swiper from 'swiper/bundle';
import { gsap, ScrollToPlugin, MotionPathPlugin, TweenMax, DrawSVGPlugin } from 'gsap/all';


const Sliders = {

  
    bannerSlider : function() {

            if ($('.js-bannerSlider')[0]) {
    
                const imagesSlider = new Swiper('.js-bannerSlider', {
                    loop: true,
                    speed: 600,
                    effect: "fade",
                    spaceBetween: 20,
                    slidesPerView: 1,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: true,
                        waitForTransition: false
                    },
                    navigation: {
                        prevEl: '.banner-button-prev',
                        nextEl: '.banner-button-next'
                    }
                });

            }
          
    },
    heroSlider : function() {

            if ($('.js-heroSlider')[0]) {
    
                const imagesSlider = new Swiper('.js-heroSlider', {
                    loop: true,
                    speed: 3200,
                    effect: "fade",
                    //autoplay: true,
                    slidesPerView: 1
                });

            }
          
    },
    highlightSlider: function() {
        if ($('.js-highlightSlider')[0]) {

            const imagesSlider = new Swiper('.js-highlightSlider', {
                loop: false,
                speed: 1200,
                effect: "fade",
                //autoHeight: true, 
                spaceBetween: 20,
                slidesPerView: 1,
                navigation: {
                    prevEl: '.highlight-button-prev',
                    nextEl: '.highlight-button-next'
                }
            });

        }
    },
    introModuleSlider: function() {
        if ($('.js-introModuleSlider')[0]) {

            const introModuleSlider = new Swiper('.js-introModuleSlider', {
                loop: false,
                speed: 1200,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: true,
                    waitForTransition: false
                },
                effect: "fade",
                //autoHeight: true, 
                slidesPerView: 1,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    prevEl: '.swiper-controls .swiper-button-prev',
                    nextEl: '.swiper-controls .swiper-button-next'
                }
            });

        }
    },
    carouselSlider: function() {
        if ($('.js-carouselSlider')[0]) {

            const carouselSlider = new Swiper('.js-carouselSlider', {
                loop: true,
                effect: "fade",
                fadeEffect: {
                    crossFade: true
                },
                autoHeight: true, 
                spaceBetween: 20,
                slidesPerView: 1,
                watchSlidesProgress: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                    waitForTransition: false
                },
                navigation: {
                    prevEl: '.carousel-button-prev',
                    nextEl: '.carousel-button-next'
                }
            });



            const svgCircleProgress1 = document.getElementById("svgCircleProgress1");
            const svgCircleProgress1Path1 = document.getElementById("svgCircleProgressPath1");
            let tween, percentElement = false;
            const circleLoader = gsap.timeline({paused:true})

            TweenMax.set(svgCircleProgress1Path1, {drawSVG:0});
            //circleLoader.set(svgCircleProgress1Path1, {drawSVG:0});

            function start(){
                tween = TweenMax.fromTo(svgCircleProgress1Path1, 5, {
                    drawSVG:"0"
                }, {
                    drawSVG:'0 100%', 
                    //onUpdate:setPercentage,
                    onComplete: repeat
                });
            }
            
            function setPercentage(){
                if (!percentElement){
                percentElement = document.getElementById("percent");
                }
                var v = Math.round((tween.progress() * 100));
                //v /= 10; // for use when you want 0.1 % use 1000 above if you do
                percentElement.innerHTML = v; // + "%";
                percentElement.style.opacity = tween.progress();
            }
          
            function repeat(){
                start();
                // using setTimeout to give a bit of a delay before re-drawing the circle
                //setTimeout(start);
            }
          
            start();

            $('.js-carouselSlider .pause-btn').on('click', function() {
                if ( !$(this).hasClass('paused')) {
                    carouselSlider.autoplay.stop();
                    tween.pause();
                    $(this).addClass('paused');
                } else {
                    carouselSlider.autoplay.start();
                    tween.restart();
                    $(this).removeClass('paused');
                }
    
            })
            $('.js-carouselSlider .carousel-button-prev, .js-carouselSlider .carousel-button-next').on('click', function() {
                carouselSlider.autoplay.stop();
                $('.js-carouselSlider .pause-btn').addClass('paused');
                tween.restart();
                tween.pause();
            })
        }
    },
    cardMobileSlider: function() {
        if ($('.js-cardMobileSlider')[0]) {

            var init = false;
            var swiper;
            function swiperCard() {
            if (window.innerWidth <= 992) {
                if (!init) {
                init = true;
                swiper = new Swiper(".js-cardMobileSlider", {
                    loop: false,
                    speed: 1200,
                    //grabCursor: true,
                    centeredSlides: true,
                    //autoHeight: true, 
                    spaceBetween: 20,
                    slidesPerView: 1.5,
                    navigation: {
                        prevEl: '.card-button-prev',
                        nextEl: '.card-button-next'
                    }
                });
                }
            } else if (init) {
                swiper.destroy();
                init = false;
            }
            }
            swiperCard();
            window.addEventListener("resize", swiperCard);

  
        }
    },
    vineyardAppellationSlider: function() {
        if ($('.js-vineyardAppellationSlider')[0]) {

            const vineyardAppellationSlider = new Swiper('.js-vineyardAppellationSlider', {
                loop: false,
                speed: 800,
                spaceBetween: 20,
                slidesPerView: 1,
                navigation: {
                    prevEl: '.vineyard-button-prev',
                    nextEl: '.vineyard-button-next'
                }
            });

            // Add click event to navigation items
            $('.nav li').on('click', function() {
                const index = $(this).data('index');
                vineyardAppellationSlider.slideTo(index);
            });

            // Update active navigation item on slide change
            vineyardAppellationSlider.on('slideChange', function() {
                const activeIndex = vineyardAppellationSlider.activeIndex;
                $('.nav li').removeClass('active');
                $('.nav li[data-index="' + activeIndex + '"]').addClass('active');
            });
        }
    },
    init: function() {
        this.bannerSlider();
        this.heroSlider();
        this.highlightSlider();
        this.carouselSlider();
        this.introModuleSlider();
        this.cardMobileSlider();
        this.vineyardAppellationSlider();
    },
};

export default Sliders;
